// src/data/serviceSettings.js
//
// SECTION 539. Bob, 2026-09-30: "Regarding recipient signature line, on some properties they have a different agreement
// regarding service between the carrier and the organization. This will have to be adjusted on each property I'm sure."
// The agreements themselves say only that a claim is presented in writing (CSX Article 20(a) adds "or electronically")
// to the officer authorized to receive it - read 2026-09-30 in each source text. HOW it is served is an understanding
// on each property, and the General Chairperson is the one who knows it. So he sets it, per agreement his committee
// holds, in serviceSettings/{committee}; the Penalty Time Claim prints the receipt line that setting names.
// Without a setting: the agreement's own default in claimRequirements.js (CSX), else the hand receipt. Pure.
import { DEFAULT_RECEIPT } from './penaltyClaim';

export const RECEIPTS = {
  hand: { label: 'Hand delivery - the recipient signs', receipt: DEFAULT_RECEIPT },
  hand_or_certified: { label: 'Hand delivery or certified mail', receipt: { left: 'Recipient’s Signature & Title, or Certified Mail No.', right: 'Date & Time Received' } },
  certified: { label: 'Certified mail', receipt: { left: 'Certified Mail No.', right: 'Date Mailed' } },
  electronic: { label: 'Electronically (e-mail or the carrier’s system)', receipt: null, note: 'Presented electronically. The transmittal and its confirmation are saved with the claim.' },
};
export const RECEIPT_KEYS = Object.keys(RECEIPTS);
export const NOTE_MAX = 200;

export function agreementSlug(name) { return String(name || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 120); }

// The agreements a committee holds, by the names its claims carry (agreementData.AGREEMENT_LOOKUP).
export function committeeAgreements(lookup, committee) {
  const byCraft = (lookup && lookup[committee]) || {};
  const names = [];
  Object.values(byCraft).forEach(rr => Object.values(rr || {}).forEach(n => { if (n && !names.includes(n)) names.push(n); }));
  return names;
}

// The service terms that apply to one claim: the GC's setting, else the agreement's default, else none (hand receipt).
export function serviceFor(agreementName, requirements, settings) {
  const set = settings && settings.agreements && settings.agreements[agreementSlug(agreementName)];
  if (set && RECEIPTS[set.receipt]) {
    const r = RECEIPTS[set.receipt];
    const note = String(set.note || '').trim() || r.note || '';
    return { receipt: r.receipt, note, setBy: 'gc', method: set.receipt };
  }
  if (requirements && requirements.service) return { ...requirements.service, setBy: 'agreement' };
  return null;
}

// The GC's write: one agreement's method and note. Validated here; the rule holds the shape.
export function settingPatch(current, agreementName, receipt, note) {
  const errors = [];
  if (!RECEIPT_KEYS.includes(receipt)) errors.push('Choose how claims are served.');
  const n = String(note || '').trim();
  if (n.length > NOTE_MAX) errors.push('The note is limited to ' + NOTE_MAX + ' characters.');
  const slug = agreementSlug(agreementName);
  if (!slug) errors.push('No agreement.');
  if (errors.length) return { ok: false, errors, value: null };
  const agreements = { ...((current && current.agreements) || {}) };
  agreements[slug] = { name: String(agreementName), receipt, note: n || null };
  return { ok: true, errors: [], value: { agreements } };
}
